import { CellPlugin } from '@react-page/editor';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

// use a type here, not an interface
type Data = {
  label: string,
  value: string
}

const getValue = (value: string) => {
  if (value && value.length > 0) {
    return value;
  } else {
    return "123456789";
  }
}

const TerminalIdentifierPropertyPlugin: CellPlugin<Data> = {
  Renderer: ({ data }) => (
      <Row>
        <Col><strong>{data.label}</strong></Col>
        <Col>{getValue(data.value)}</Col>
      </Row>
  ),
  id: 'terminalIdentifierPropertyPlugin',
  title: 'Terminal Identifier Property',
  description: 'Terminal Identifier Property.',
  version: 1,
  controls: {
    type: 'autoform',
    schema: {
      properties: {
        label: {
          type: 'string',
          default: 'Terminal Identifier',
        },

      },
      required: ['label'],
    },
  },
};

export default TerminalIdentifierPropertyPlugin;